import { createContext } from 'react'

export const FileUploadContext = createContext({
  dropping: false,
})
